import { render } from "./StandardPaymentMethodSelect.vue?vue&type=template&id=560cf638"
import script from "./StandardPaymentMethodSelect.vue?vue&type=script&lang=js"
export * from "./StandardPaymentMethodSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__